import { CollectionsState } from './types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const collectionsState = (state: RootState): CollectionsState => state.collections;

export const selectResourceCollections = createSelector([collectionsState], collections => {
  return collections?.collections;
});

export const selectResourceCollectionsLoading = createSelector([collectionsState], collections => collections?.loading);

export const selectResourceCollectionsError = createSelector([collectionsState], collections => collections?.error);

export const selectGetCollectionsStatus = createSelector(
  [collectionsState],
  collections => collections?.getCollections,
);
